import { jsx as _jsx } from "react/jsx-runtime";
import React, { createContext, useContext } from 'react';
const TextFieldMobileModeContext = /*#__PURE__*/ createContext(false);
export function TextFieldMobileModeProvider(param) {
    let { enabled, children } = param;
    return /*#__PURE__*/ _jsx(TextFieldMobileModeContext.Provider, {
        value: enabled,
        children: children
    });
}
export function useTextFieldMobileMode() {
    return useContext(TextFieldMobileModeContext);
}
